import {
  updateMeetingRoomUsageConfirmAlarm,
  updateMeetingRoomUsageConfirmAlarmTarget,
  updateMeetingRoomUsageConfirmAlarmTime,
} from "apis/meeting-settings/alarm";
import { ITodayRoomNotificationSettings } from "./types";
import { MEETING_ALARM_TARGET } from "types/meeting-settings.types";

//* 당일 회의실 이용 확인 알림 설정 UI 서비스
export const todayRoomNotificationSettingsService: ITodayRoomNotificationSettings = {
  onChangeActivate: async (
    value: boolean,
    setChangeActive: (value: boolean) => void,
    setOpenAlertModal: (value: boolean) => void,
    showToast: (message: string, type: "success" | "error") => void
  ) => {
    const res = await updateMeetingRoomUsageConfirmAlarm(value);

    if (res.success) {
      setChangeActive(value);
      setOpenAlertModal(false);
      showToast("변경사항이 성공적으로 저장되었습니다.", "success");
    } else {
      showToast("변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요.", "error");
    }
  },

  onChangeTime: async (
    value: string,
    setChangeTime: (value: string) => void,
    showToast: (message: string, type: "success" | "error") => void
  ) => {
    const res = await updateMeetingRoomUsageConfirmAlarmTime(value);

    if (res.success) {
      setChangeTime(value);
      showToast("변경사항이 성공적으로 저장되었습니다.", "success");
    } else {
      showToast("변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요.", "error");
    }
  },

  onChangeTarget: async (
    value: MEETING_ALARM_TARGET,
    setChangeTarget: (value: MEETING_ALARM_TARGET) => void,
    showToast: (message: string, type: "success" | "error") => void
  ) => {
    const res = await updateMeetingRoomUsageConfirmAlarmTarget(value);
    if (res.success) {
      setChangeTarget(value);
      showToast("변경사항이 성공적으로 저장되었습니다.", "success");
    } else {
      showToast("변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요.", "error");
    }
  },
};
